import LatoRegular from "../../../font/Lato-Regular.ttf";
import LatoLight from "../../../font/Lato-Light.ttf";
import LatoSemiBold from "../../../font/Lato-SemiBold.ttf";
import LatoBold from "../../../font/Lato-Bold.ttf";
import notoBold from "../../../font/noto-sans-jp-japanese-Bold.ttf";
import notoSemiBold from "../../../font/noto-sans-jp-japanese-SemiBold.ttf";
import notoLight from "../../../font/noto-sans-jp-japanese-Light.ttf";
import notoRegular from "../../../font/noto-sans-jp-japanese-Regular.ttf";
 
import { createGlobalStyle } from "styled-components";
import { useSelector } from "react-redux";
 
const GlobalFont = () => {
  const { persistItemsReducer } = useSelector((state) => state);
  const condition =
    persistItemsReducer?.selectedSOData?.soCode === "JPNO" ? true : false;
  const fontUrlRegular = condition ? notoRegular : LatoRegular;
  const fontUrlLight = condition ? notoLight : LatoLight;
  const fontUrlSemiBold = condition ? notoSemiBold : LatoSemiBold;
  const fontUrlBold = condition ? notoBold : LatoBold;
  const GlobalStyle = createGlobalStyle`
   @font-face {
    font-family: 'Lato';
    src: url(${(props) => props.regular}) format('truetype');
  }
@font-face {
  font-family: 'Lato-Light';
  src: url(${(props) => props.light}) format('truetype');
}
@font-face {
  font-family: 'Lato-Bold';
  src: url(${(props) => props.bold}) format('truetype')
}
@font-face {
  font-family: 'Lato-SemiBold';
  src: url(${(props) => props.semiBold}) format('truetype');
}
`;
  return (
    <GlobalStyle
      regular={fontUrlRegular}
      light={fontUrlLight}
      semiBold={fontUrlSemiBold}
      bold={fontUrlBold}
    />
  );
};
export default GlobalFont;
 